import { getEnumLabel } from "./commissionEnums";

export const REFERRAL_ATTRIBUTION_STATUS_LABELS = {
  Visited: "بازدید",
  Registered: "ثبت‌نام‌شده",
  ProjectCreated: "پروژه ایجادشده",
  Converted: "تبدیل‌شده",
  Expired: "منقضی‌شده",
  Cancelled: "لغوشده",
};

/** Matches Entities.FIN.ReferralAttributionStatus (Visited=1 … Cancelled=6). */
const REFERRAL_ATTRIBUTION_STATUS_BY_VALUE = {
  1: "Visited",
  2: "Registered",
  3: "ProjectCreated",
  4: "Converted",
  5: "Expired",
  6: "Cancelled",
};

export const COMMISSION_AUDIT_ENTITY_LABELS = {
  CommissionGroup: "گروه پورسانتی",
  CommissionRule: "قانون پورسانت",
  PartnerTeamShare: "سهم تیم",
  PartnerStatus: "وضعیت نماینده",
  ManualCommissionApproval: "تأیید دستی پورسانت",
  PayoutApproval: "تأیید تسویه پورسانت",
  PartnerPayout: "درخواست تسویه",
  PartnerCommission: "پورسانت",
};

export const COMMISSION_AUDIT_ACTION_LABELS = {
  Created: "ایجاد",
  Updated: "به‌روزرسانی",
  Activated: "فعال‌سازی",
  Deactivated: "غیرفعال‌سازی",
  Approved: "تأیید",
  Rejected: "رد",
  AutoGenerated: "تولید خودکار",
};

export const getAttributionStatusLabel = (status) => {
  if (status == null || status === "") return "—";
  // API may send enum as number (1..6) or name ("Visited")
  const name =
    REFERRAL_ATTRIBUTION_STATUS_BY_VALUE[status] ??
    REFERRAL_ATTRIBUTION_STATUS_BY_VALUE[Number(status)] ??
    status;
  return getEnumLabel(REFERRAL_ATTRIBUTION_STATUS_LABELS, name);
};

export const getAuditEntityLabel = (entityType) =>
  getEnumLabel(COMMISSION_AUDIT_ENTITY_LABELS, entityType);

export const getAuditActionLabel = (actionType) =>
  getEnumLabel(COMMISSION_AUDIT_ACTION_LABELS, actionType);

export const formatMonthLabel = (year, month) => {
  if (!year || !month) return "—";
  const date = new Date(year, month - 1, 1);
  return date.toLocaleDateString("fa-IR", { year: "numeric", month: "long" });
};
